import { render, staticRenderFns } from "./commonLoading.vue?vue&type=template&id=320d5471&scoped=true"
import script from "./commonLoading.vue?vue&type=script&lang=js"
export * from "./commonLoading.vue?vue&type=script&lang=js"
import style0 from "./commonLoading.vue?vue&type=style&index=0&id=320d5471&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d5471",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('320d5471')) {
      api.createRecord('320d5471', component.options)
    } else {
      api.reload('320d5471', component.options)
    }
    module.hot.accept("./commonLoading.vue?vue&type=template&id=320d5471&scoped=true", function () {
      api.rerender('320d5471', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonLoading.vue"
export default component.exports